import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5f3ca2bd&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5f3ca2bd&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ca2bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3ca2bd')) {
      api.createRecord('5f3ca2bd', component.options)
    } else {
      api.reload('5f3ca2bd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5f3ca2bd&scoped=true&", function () {
      api.rerender('5f3ca2bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/case/changeRequest/index.vue"
export default component.exports